import * as PIXI from 'pixi.js';

export default class ReferenceObject extends PIXI.utils.EventEmitter {

}